import { Github, Linkedin, Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/contexts/LanguageContext";
import loLogo from "@/assets/lo-logo.svg";

const navLinks = [
  { label: "About", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  const { t } = useTranslation();
  const copyright = (t("footer.copyright") as string).replace("{year}", String(new Date().getFullYear()));

  return (
    <footer className="border-t border-border px-6 pt-14 pb-8">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src={loLogo}
                alt="LO logo"
                className="h-7 w-auto dark:invert dark:brightness-200"
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Solutions consultant and POC builder. Virginia, USA.
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground mb-4">
              Navigate
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground mb-4">
              Connect
            </h4>
            <div className="flex items-center gap-3 mb-4">
              <a
                href="https://github.com/lesteroliver911"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="p-2 rounded-lg border border-border text-muted-foreground hover:text-foreground hover:border-foreground/40 transition-colors"
              >
                <Github size={16} />
              </a>
              <a
                href="https://linkedin.com/in/lesteroliver"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="p-2 rounded-lg border border-border text-muted-foreground hover:text-foreground hover:border-foreground/40 transition-colors"
              >
                <Linkedin size={16} />
              </a>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 text-sm text-foreground hover:text-muted-foreground transition-colors group"
            >
              <Mail size={14} />
              Get in touch
              <ArrowUpRight
                size={14}
                className="opacity-60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </Link>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>{copyright}</span>
          <Link to="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
